import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import JsonExcel from 'vue-json-excel'
import * as echarts from 'echarts'
import  'echarts/theme/macarons.js'
import Print from 'vue-print-nb'
import * as xxx from 'xlsx'
// import FileSaver as filesave from 'file-saver'

Vue.use(Print);
Vue.prototype.$echarts = echarts
Vue.prototype.$xlsx = xxx
// Vue.prototype.$fff = filesave
Vue.component('downloadExcel', JsonExcel)
// 172.19.100.12:8080
// 设置反向代理，前端请求默认发送到 https://localhost:443/api
//http://192.168.20.101:8080/   110.40.178.175 https://chengmei.games:443/api
var axios = require('axios')
Vue.prototype.$axios = axios
axios.defaults.baseURL = 'https://dy.darknight.games/api'
// axios.defaults.baseURL = 'https://localhos:4444/api'
axios.defaults.withCredentials = true


// 全局注册，之后可在其他组件中通过 this.$axios 发送数据
Vue.use(router)
Vue.use(VueAxios,axios)
Vue.use(ElementUI)



Vue.config.productionTip = false

// 从 localStorage 恢复用户信息
const savedUser = window.localStorage.getItem('user')
if (savedUser) {
  try {
    const user = JSON.parse(savedUser)
    store.commit('login', user)
    console.log('从 localStorage 恢复用户信息:', user)
  } catch (e) {
    console.error('恢复用户信息失败:', e)
    window.localStorage.removeItem('user')
  }
}

router.beforeEach((to, from, next) => {



      if (to.meta.requireAuth) {

        if (store.state.user) {

            // axios.defaults.baseURL='https://chengmei.games:443/api'

            axios.get('/authentication').then(resp => {

                console.log(resp.data)
                if (resp.data === true) {

                    next()

                } else {

                    alert("请先登录")

                    next({

                        path: 'login',
                        query: {redirect: to.fullPath}
                    })
            }
            }).catch(function (error) {
                alert("请先登录");
                console.log(error)


                next({

                    path: 'login',
                    query: {redirect: to.fullPath}
                })
            })

          // next()
        } else {
          alert("请先登录！")
            console.log("未登录")
          next({

            path: 'login',
            query: {redirect: to.fullPath}
          })
        }

          // axios.defaults.baseURL='https://data.darknight.games/api'
      } else {
        next()
      }
    }
)



new Vue({
  el:'#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount("#app")




